/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  PopupDialog,
  dublicateAlert,
  errorAlert,
  messageAlert,
  moneyFormat,
} from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import {
  Box,
  Button,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core';
import { PriceTotal } from '../Shared/TotalPrice';
import { useLazyQuery } from '@apollo/client';
import { getOperationSalaryitems, getUnPaidSalaryitems } from '../graphql';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import { CalenderLocal, TextFieldLocal } from '../components';
import { parents } from '../constants/kaid';
import useAccounts from '../hooks/useAccounts';
import { successAlert } from '../Shared/helpers';
import SalaryItemsTable from '../Shared/SalaryItemsTable';
import { updateDocTotal } from '../Sections/HR/Salaryitems';
import _ from 'lodash';
import MonthNavigator from '../Shared/MonthNavigator';
import { itemClasses } from '../themes/classes';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupSalaryPayment = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  theme,
}: any) => {
  const classes = itemClasses();

  const [saving, setSaving] = useState(false);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [rowsb, setRowsb] = useState([]);
  const [rows, setRows] = useState([]);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [cridaccounts, setCridaccounts] = React.useState([]);
  const [creditAcc, setCreditAcc]: any = React.useState(null);
  const [openlist, setOpenlist]: any = React.useState(false);

  const [amount, setAmount] = useState<any>({});

  const { accounts } = useAccounts();
  const {
    translate: { words, isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const [loadSalaryitems, opData]: any = useLazyQuery(getUnPaidSalaryitems, {
    fetchPolicy: 'cache-and-network',
  });
  const [loadOpSalaryitems, opSalData]: any = useLazyQuery(
    getOperationSalaryitems,
    {
      fetchPolicy: 'cache-and-network',
    }
  );

  useEffect(() => {
    if (isNew) {
      if (opData?.data?.getUnPaidSalaryitems?.data) {
        const { data } = opData.data.getUnPaidSalaryitems;
        const rdata = updateDocTotal({ data, isRTL });
        setRows(rdata);
      }
    }
  }, [opData]);
  useEffect(() => {
    if (opData?.data?.getUnPaidSalaryitems?.data) {
      const { data } = opData.data.getUnPaidSalaryitems;
      const rdata = updateDocTotal({ data, isRTL });
      setRowsb(rdata);
    }
  }, [opData]);

  const clearDataList = () => {
    setRows([]);
  };
  const fillDataList = () => {
    if (opData?.data?.getUnPaidSalaryitems?.data) {
      const { data } = opData.data.getUnPaidSalaryitems;
      const rdata = updateDocTotal({ data, isRTL });
      setRows(rdata);
    }
  };

  useEffect(() => {
    if (isNew) {
      setMonth(new Date().getMonth());
      setYear(new Date().getFullYear());
    }
  }, [open]);

  useEffect(() => {
    if (row && row?._id) {
      if (opSalData?.data?.getOperationSalaryitems?.data) {
        const { data } = opSalData.data.getOperationSalaryitems;
        const rdata = updateDocTotal({ data, isRTL });
        setRows(rdata);
      }
    }
  }, [opSalData]);

  const { handleSubmit, register, reset, errors } = useForm({});

  const removeItemFromList = (id: any) => {
    const newList = rows.filter((item: any) => item?._id !== id);
    setRows(newList);
  };

  const handleDateChange = (date: any) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    setAmount(_.sumBy(rows, 'total'));
  }, [rows]);

  useEffect(() => {
    if (row && row._id) {
      const ca = row.creditAcc;
      const links = row?.links;
      loadOpSalaryitems({
        variables: { ids: links },
      });

      if (ca) {
        const credit = accounts.filter((acc: any) => acc.code === ca)[0];
        setCreditAcc(credit);
      }
      handleDateChange(row.time);
    }
  }, [open, accounts]);

  useEffect(() => {
    const cashaccounts = accounts.filter(
      (acc: any) => acc.parentcode === parents.CASH && acc.code < 1070
    );
    setCridaccounts(cashaccounts);
    loadSalaryitems({ variables: { month, year } });
  }, [open, month, year]);

  const onSubmit = async (data: any) => {
    if (!rows || rows.length === 0) {
      await messageAlert(
        setAlrt,
        isRTL
          ? `يجب اضافة عنصر (مصروف) واحد للمستند على الأقل`
          : `You should add min one expense to document`
      );
      return;
    }
    if (!creditAcc) {
      await messageAlert(
        setAlrt,
        isRTL ? 'يجب تحديد الحساب' : 'You have to select Account'
      );
      return;
    }
    setSaving(true);

    const { title, desc } = data;

    const links = rows?.map((item: any) => item?._id);

    const variables: any = {
      _id: row && row._id ? row._id : undefined,
      time: selectedDate,
      creditAcc: creditAcc.code,
      amount,
      links,
      title,
      desc,
    };
    const mutate = isNew ? addAction : editAction;
    apply(mutate, variables);
  };

  const apply = async (mutate: any, variables: any) => {
    try {
      await mutate({ variables });
      await successAlert(setAlrt, isRTL);
      setSaving(false);
      onCloseForm();
    } catch (error) {
      onError(error);
      console.log(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      console.log(error);
    }
  };

  const resetAllForms = () => {
    reset();
    setCreditAcc(null);
    setRows([]);
    setAmount(0);
    setSelectedDate(new Date());
    setSaving(false);
  };

  const onCloseForm = () => {
    resetAllForms();
    onClose();
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const addItemToList = (item: any) => {
    const isinlist = rows.filter((it: any) => it._id === item?._id)?.[0];
    if (isinlist) return;
    const newlist = [...rows, item];
    setRows(newlist);
  };

  const title = isRTL
    ? isNew
      ? 'اضافة دفعة'
      : 'تعديل دفعة'
    : isNew
    ? 'New Payment'
    : 'Edit Payment';
  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onCloseForm}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      maxWidth="lg"
      saving={saving}
      mt={0}
      mb={20}
    >
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <CalenderLocal
            isRTL={isRTL}
            label={words?.time}
            value={selectedDate}
            onChange={handleDateChange}
          ></CalenderLocal>
        </Grid>
        <Grid item xs={4}>
          <Box style={{ marginTop: 15 }}>
            <AutoFieldLocal
              name="creditAcc"
              title={isRTL ? 'حساب الدفع' : 'Payment Acc'}
              words={words}
              options={cridaccounts}
              value={creditAcc}
              setSelectValue={setCreditAcc}
              register={register}
              isRTL={isRTL}
              fullwidtth
              mb={0}
              nosort
            ></AutoFieldLocal>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display={'flex'}>
            <MonthNavigator
              isRTL={isRTL}
              month={month}
              year={year}
              setMonth={setMonth}
              setYear={setYear}
            ></MonthNavigator>
            <Box style={{ width: 40 }}></Box>
            <Button
              style={{
                marginLeft: 20,
                marginRight: 20,
                paddingLeft: 10,
                paddingRight: 10,
              }}
              onClick={clearDataList}
            >
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {isRTL ? 'مسح الكل' : 'Clear All'}
              </Typography>
            </Button>
            <Button
              style={{
                marginLeft: 20,
                marginRight: 20,
                paddingLeft: 10,
                paddingRight: 10,
              }}
              onClick={() => setOpenlist(true)}
            >
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {isRTL ? 'اضافة' : 'Add'}
              </Typography>
            </Button>
            <Button
              style={{
                marginLeft: 20,
                marginRight: 20,
                paddingLeft: 10,
                paddingRight: 10,
              }}
              onClick={fillDataList}
            >
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {isRTL ? 'اضافة الكل' : 'Add All'}
              </Typography>
            </Button>
          </Box>
          <Box
            style={{
              backgroundColor: '#f3f3f3',
              padding: 10,
              borderRadius: 10,
              marginTop: 10,
            }}
          >
            <SalaryItemsTable
              rows={rows}
              removeItem={removeItemFromList}
              isRTL={isRTL}
              words={words}
            ></SalaryItemsTable>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <PriceTotal
            amount={amount}
            total={amount}
            words={words}
            totalonly
            end={false}
          ></PriceTotal>
        </Grid>
        <Grid item xs={8}>
          <TextFieldLocal
            name="desc"
            label={words.description}
            register={register}
            multiline
            rows={3}
            errors={errors}
            row={row}
            fullWidth
            mb={0}
          />
        </Grid>
        <PopupDialog
          open={openlist}
          onClose={() => setOpenlist(false)}
          maxWidth="md"
          classes={classes}
        >
          <DialogContent>
            <List style={{ minWidth: 200, padding: 10 }}>
              {rowsb.map((item: any) => {
                return (
                  <ListItem
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      addItemToList(item);
                      setOpenlist(false);
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography style={{ fontWeight: 'bold' }}>
                          {isRTL ? item?.employeeNameAr : item?.employeeName}
                        </Typography>
                      }
                      secondary={moneyFormat(item?.total)}
                    />
                  </ListItem>
                );
              })}
            </List>
          </DialogContent>
        </PopupDialog>
      </Grid>
    </PopupLayout>
  );
};

export default PopupSalaryPayment;
